import locationsReducer from "./reducers/locationsReducer";

export default locationsReducer;
